<app-sub-navbar [searchkey]="searchkey"></app-sub-navbar>

<!-- content -->
<section class="py-3">
  <section class="container-fluid my-md-4 bd-layout">
    <aside class="bd-sidebar">
      <nav class="collapse bd-links" id="filterz" aria-label="filterz">
        <ul class="list-unstyled mb-0 py-3 pt-md-1">
          <li class="mb-1">
            <button class="btn d-inline-flex align-items-center rounded collapsed" data-bs-toggle="collapse"
              data-bs-target="#explore" aria-expanded="false">
              Categories
            </button>
            <div class="collapse show" id="explore">
              <ul class="list-unstyled fw-normal pb-1 small">
                <li *ngFor="let cate of cateData">
                  <a [routerLink]="['/search/']" [queryParams]="{
                      cate: cate.categoryName,
                      searchKey: searchkey
                    }" class="d-inline-flex align-items-center rounded">{{ cate.categoryName }}</a>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-1">
            <button class="btn d-inline-flex align-items-center rounded collapsed" data-bs-toggle="collapse"
              data-bs-target="#sort-by" aria-expanded="false">
              Sort by
            </button>
            <div class="collapse" id="sort-by">
              <ul class="align list-unstyled fw-normal pb-1 small">
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked
                      (change)="sortBy('popular')" />
                    <label class="form-check-label" for="flexRadioDefault2">
                      Popular
                    </label>
                  </div>
                </li>

                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                      (change)="sortBy('recent')" />
                    <label class="form-check-label" for="flexRadioDefault1">
                      Recent
                    </label>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3"
                      (change)="sortBy('free')" />
                    <label class="form-check-label" for="flexRadioDefault3">
                      Free
                    </label>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault4"
                      (change)="sortBy('pro')" />
                    <label class="form-check-label" for="flexRadioDefault4">
                      Pro
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </aside>

    <div class="container overflow-hidden">
      <!-- Illustrations -->

      <!-- <h5 *ngIf="visibleCollectionData.length > 0 || visibleCollectionsDataCard.length > 0">
        Here are your search results!
      </h5> -->

      <h5 *ngIf="
            (searchkey !== 'Collections' && visibleCollectionData.length > 0) ||
            (searchkey === 'Collections' && visibleCollectionsDataCard.length > 0)
          ">
        Here are your search results!
      </h5>

      <div class="masonry-container mb-4" #masonryContainer *ngIf="
          searchkey == 'Illustration' ||
          (searchkey == 'AI Images' && searchType != 'Collections')
        ">
        <!-- Show skeletons while loading -->

        <div class="masonry-item" *ngFor="let data of visibleCollectionData; let i = index">
          <figure class="showcase">
            <div class="badge-wrap" *ngIf="data.isPremium && data.imageLoad">
              <span class="badge rounded cursor text-bg-dark">Pro</span>
            </div>

            <!-- Skeleton (auto visible before image load) -->
            <div class="skeleton" *ngIf="!data.imageLoad"></div>

            <a *ngIf="data.jpeg || data.png" [routerLink]="
                searchkey === 'AI Images'
                  ? '/ai-image/' + data.slug
                  : '/illustration/' + data.slug
              ">
              <!-- data?.previewUrl || data.jpeg || data.png  -->
              <img [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title"
                class="radius-md img-fluid" (load)="onImageLoad(i, $event)" loading="lazy" />

              <figcaption class="hide-caption figure-caption">
                <p>{{ data.title }}</p>
              </figcaption>
            </a>
          </figure>
        </div>

        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
          *ngIf="!isDataLoading && visibleCollectionData.length === 0">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              {{ searchkey }} not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the {{ searchkey | lowercase }} at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>
      </div>
      <!-- 🔹 Load More Row (SEPARATE ROW) -->
      <div class="row my-4" *ngIf="!loader && hasMoreIllus">
        <div class="col-12 d-flex justify-content-center">

          <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreIllus()" [disabled]="isLoadingMore">

            <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm"></span>

            <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>

          </button>

        </div>
      </div>



      <br *ngIf="
          searchkey != undefined &&
          searchkey != 'Collections' &&
          searchType != 'Collections'
        " />

      <!-- Collections -->
      <!-- <h5
        *ngIf="
          visibleCollectionsDataCard.length > 0 &&
          searchkey != undefined &&
          searchkey == 'AI Images'
        ">
        Explore collections here!
      </h5> -->

      <h5 *ngIf="
            searchkey === 'AI Images' &&
            searchType === 'Collections' &&
            visibleCollectionsDataCard.length > 0
          ">
        Explore collections here!
      </h5>


      <div class="row row-cols-lg-4 py-3" *ngIf="
        
          (searchkey != undefined && searchkey == 'Collections') ||
          (searchkey != undefined &&
            searchkey == 'AI Images' &&
            searchType == 'Collections')
        ">
        <div class="col-md-4 mb-4" *ngFor="let data of visibleCollectionsDataCard">
          <figure class="skeleton--image position-relative">
            <a *ngIf="data.tUrl" [routerLink]="
                aiImages
                  ? '/ai-image-collection/' + data.slug
                  : '/illustration-collection/' + data.slug
              ">
              <div class="card collection-radius">
                <img [src]="getSEOImage(data.tUrl)" [alt]="data.name" class="img-fluid rounded-top"
                  [class.skeleton--image]="!data.imageLoad" (load)="data.imageLoad = true" />
                <div class="card-body border-top">
                  <p class="fw-semi text-dark card-text overflow-text">{{ data.name }}</p>
                </div>
              </div>
            </a>
          </figure>
        </div>

        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
          *ngIf="!isDataLoading && visibleCollectionsDataCard.length === 0">
          <div class="container">
            <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg" alt="No Data Found" />
            <h1 class="fw-bold fs-4 text-dark mb-2">
              {{
              searchkey == "AI Images" ? "AI Image Collections" : searchkey
              }}
              not available
            </h1>
            <p class="mb-4 text-dark">
              We couldn't load the
              {{
              searchkey == "AI Images" ? "AI Image Collections" : searchkey
              }}
              at the moment.
            </p>
            <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
          </div>
        </div>

        <!-- 🔹 Load More Row (SEPARATE ROW) -->
        <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="!loader && hasMoreCollection">
          <div class="col-12 d-flex justify-content-center">

            <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreCollection()"
              [disabled]="isCollectionsLoadingMore">

              <span *ngIf="isCollectionsLoadingMore" class="spinner-border spinner-border-sm"></span>

              <span>{{ isCollectionsLoadingMore ? 'Loading...' : 'Load more' }}</span>

            </button>

          </div>
        </div>
      </div>


      <!-- 
      <div class="py-3 pad-top px-4 text-center">
        <a routerLink="/" class="btn btn-ib-red">
          Next Page &nbsp;<i class="fas fa-arrow-right"></i
        ></a>
      </div> -->
    </div>
  </section>
</section>